var ni=Object.defineProperty,ii=Object.defineProperties;var ri=Object.getOwnPropertyDescriptors;var he=Object.getOwnPropertySymbols;var Je=Object.prototype.hasOwnProperty,et=Object.prototype.propertyIsEnumerable;var Qe=(e,t,o)=>t in e?ni(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,A=(e,t)=>{for(var o in t||(t={}))Je.call(t,o)&&Qe(e,o,t[o]);if(he)for(var o of he(t))et.call(t,o)&&Qe(e,o,t[o]);return e},P=(e,t)=>ii(e,ri(t));var Oe=(e,t)=>{var o={};for(var a in e)Je.call(e,a)&&t.indexOf(a)<0&&(o[a]=e[a]);if(e!=null&&he)for(var a of he(e))t.indexOf(a)<0&&et.call(e,a)&&(o[a]=e[a]);return o};var ee=(e,t,o)=>new Promise((a,l)=>{var p=c=>{try{n(o.next(c))}catch(d){l(d)}},s=c=>{try{n(o.throw(c))}catch(d){l(d)}},n=c=>c.done?a(c.value):Promise.resolve(c.value).then(p,s);n((o=o.apply(e,t)).next())});import{Col as Ln,Container as Pi,Row as Pn}from"react-grid-system";import{useWindowSize as zi,useIsIntersecting as Oi}from"@msgtechnology/ui";import li from"react";import{css as tt,styled as ai}from"styled-components";var X=tt`
  width: 100%;
  margin: 0;
  line-height: 1.1;
`,Q=tt`
  line-height: 1.2;
`,St=ai.div`
  .level-1 {
    ${X}
    font-size: 32px; //var(--font-size-h1-mobile);
    font-weight: 200; //var(--font-weight-ultra-light);

    @media (min-width: 768px) {
      ${Q}
      font-size: 48px; //var(--font-size-h1-desktop);
    }
  }

  .level-2 {
    ${X}
    font-size: 24px; //var(--font-size-h2-mobile);
    font-weight: 600; //(--font-weight-extra-bold);
    margin-bottom: 25px;
    margin-top: 30px;
    color: #c6c6c6; //var(--gray-200);

    @media (min-width: 768px) {
      ${Q}
      font-size: 28px; //var(--font-size-h2-desktop);
      margin-bottom: 35px;
    }
  }

  .level-3 {
    ${X}
    font-size: 20px; //var(--font-size-h3-mobile);
    font-weight: 400; //(--font-weight-semi-bold);
    margin-bottom: 19px;
    margin-top: 45px;

    @media (min-width: 768px) {
      ${Q}
      font-size: 22px; //var(--font-size-h3-desktop);
    }

    a {
      color: '#fff'; //(--white);
      transition: all 0.2s linear; //var(--link-color-transition);
      cursor: pointer;
      text-decoration: none;

      &:hover {
        color: '#e2e2e2'; //var(--link-color-white-hover);
      }
    }
  }

  .level-4 {
    ${X}
    font-size: 18px; //var(--font-size-h4-mobile);
    font-weight: 600; //(--font-weight-extra-bold);

    @media (min-width: 768px) {
      ${Q}
      font-size: 20px; //var(--font-size-h4-desktop);
    }

    a {
      color: '#fff'; //var(--white);
      transition: all 0.2s linear; //var(--link-color-transition);
      cursor: pointer;
      text-decoration: none;

      &:hover {
        color: '#e2e2e2'; //var(--link-color-white-hover);
      }
    }
  }

  .level-5 {
    ${X}
    font-size: 16px; //var(--font-size-h5-mobile);
    font-weight: 500; //(--font-weight-bold);
    margin-bottom: 20px;

    @media (min-width: 768px) {
      ${Q}
      font-size: 18px; //var(--font-size-h5-desktop);
    }
  }

  .level-6 {
    ${X}
    font-size: 15px; //var(--font-size-h6-mobile);
    font-weight: 600; //(--font-weight-extra-bold);
    margin-bottom: 20px;
    text-transform: lowercase;

    @media (min-width: 768px) {
      ${Q}
      font-size: 16px; //var(--font-size-h6-desktop);
    }
  }

  .level-display {
    ${X}
    font-size: 48px; //var(--font-size-specialty-display-mobile);
    font-weight: 200; //var(--font-weight-ultra-light);

    @media (min-width: 768px) {
      ${Q}
      font-size: 64px; //var(--font-size-specialty-display-desktop);
    }
  }

  .eyebrow {
    ${X}
    font-size: 14px; //var(--font-size-specialty-label-mobile);
    font-weight: 600; //(--font-weight-extra-bold);
    margin-bottom: 20px;
    letter-spacing: 0.105em;
    text-transform: uppercase;

    @media (min-width: 768px) {
      ${Q}
      font-size: 16px; //var(--font-size-specialty-label-desktop);
    }
  }

  .to-uppercase {
    text-transform: uppercase;
  }

  &.justify-center {
    text-align: center;
  }
`;var J=d=>{var C=d,{children:e,level:t,levelDisplay:o,isEyebrow:a=!1,isUppercase:l=!1,justify:p="left",title:s="",margin:n}=C,c=Oe(C,["children","level","levelDisplay","isEyebrow","isUppercase","justify","title","margin"]);let T=`level-${o||t} `+(p==="center"?`justify-${p} `:"")+(a?"eyebrow ":"")+(l?"to-uppercase":""),$=`h${t}`,k=e||s,S=D=>{var V=Oe(D,[]);return li.createElement($,V)};return<St><S style={A({whiteSpace:"pre-line",margin:n},c)}className={T}>{typeof k=="string"?k.split("<br />").join(`
`):k}</S></St>};import{useState as Do,useCallback as vi,useEffect as Me,useRef as To}from"react";import{JsonLD as Si,useIsIntersecting as Ci,useWindowSize as ki}from"@msgtechnology/ui";import{useState as Rt,useRef as di,useEffect as pi,useCallback as Bt}from"react";import{styled as ae}from"styled-components";var Ct=ae.div`
  padding-bottom: 24px; //var(--spacing-4);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  gap: 8px;
  color: #fff;

  &:hover {
    img {
      opacity: 1;
    }
  }

  img {
    border-radius: 8px; //var(--spacing-1);
    opacity: 1;
    transition: opacity 0.3s linear;
    aspect-ratio: 16/9;

    @media (hover: hover) {
      opacity: 0.8;
    }
  }
`,$t=ae.div`
  .level-3 {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    font-weight: 350; //var(--font-weight-light);
    width: 100%;
    margin: ${e=>e.$isStudent?"0px":"8px 0"}; //var(--spacing-1) var(--spacing-0);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: ${e=>e.$isStudent?"reset":"18px"};

    @media (max-width: 767px) {
      word-break: ${e=>e.$isStudent?"break-all":"break-word"};
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      font-size: 16px; //var(--font-size-h5-mobile);
      line-height: ${e=>e.$isStudent?"100%":"120%"};
      font-weight: ${e=>e.$isStudent?400:350};
    }
  }
`,It=ae.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  position: relative;
`,Mt=ae.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`,Fe=ae.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  display: -webkit-box;
  word-wrap: break-word;
  color: #fff;
  //min-height: 3em;
  margin: 0;
  gap: 8px;
  font-style: ${e=>e.$fontStyle?e.$fontStyle:"normal"};

  @media (max-width: 767px) {
    font-size: 12px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
`,Vt=ae.button`
  display: flex;
  padding: 8px 16px;
  align-items: center;
  border-radius: 40px;
  border: 1px solid #05c3dd;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-weight: 300;
  justify-content: center;
  align-self: flex-start;
  cursor: pointer;

  @media (max-width: 767px) {
    align-self: stretch;
  }

  &:hover {
    background: linear-gradient(248deg, #05c3dd 27.85%, #20ffff 81.23%);
    color: #000;
  }
`;var He=(l=>(l.Elementary="Elementary_School",l.Middle="Middle_School",l.High="High_School",l.College="College",l))(He||{}),ye=["","","","","4th Grade","5th Grade","6th Grade","7th Grade","8th Grade","9th Grade","10th Grade","11th Grade","12th Grade","Freshman","Sophomore","Junior","Senior","Grad Student"];var Et=({title:e,educationLevel:t,schoolName:o,openModal:a,isVotingOpen:l})=><Mt><div><Fe>{`${ye[t]}, ${o}`}</Fe><Fe $fontStyle="italic">{e}</Fe></div>{l()?<Vt onClick={a}>Vote</Vt>:null}</Mt>;import{styled as Dt}from"styled-components";var Tt=Dt.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: flex-start;
`,At=Dt.div`
  height: 20px;
  background-color:${e=>e.$tagColor};
  color: #ABABAB;
  padding: 4px 8px;
  text-transform: uppercase;
  line-height: 100%;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2.4px;
  border-radius: 2px;
  white-space: nowrap;
  word-break: keep-all;
  text-align: center;
  vertical-align: middle;
  max-width: 100%;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
`;var si={category:"#535353",industry:"#3E3E3E",goal:"#303030"},Nt=({tags:e})=>!Array.isArray(e)||e.length===0?null:<Tt>{e.map((t,o)=><At $tagColor={si[t.category]}key={o}>{t.name}</At>)}</Tt>;var Lt=({posterImage:e,videoTitle:t,useDetailsSlug:o,onClick:a,openModal:l,nextImage:p,thumbnail:s,enableVideoHover:n,loDefVideo:c,voteDetails:d,tags:C,showTags:T})=>{let[$,k]=Rt(!1),[S,V]=Rt(!1),D=di(null),O=()=>{k(!0)},F=()=>{k(!1),V(!1),D.current&&(D.current.pause(),D.current.currentTime=0)};pi(()=>()=>{D.current&&(D.current.pause(),D.current.currentTime=0)},[]);let N=Bt(()=><video ref={D}src={c}style={{width:"100%",height:"auto",borderRadius:"8px"}}loop muted playsInline onCanPlay={()=>{var f;V(!0),(f=D.current)==null||f.play()}}onError={f=>{console.log("Video failed to load: ",f),k(!1)}}/>,[$,c]),R=Bt(()=>p||(s||e?<img src={s||e}alt="Video thumbnail"style={{width:"100%",height:"auto"}}/>:null),[p,s,e]);return<>{(e||s||p)&&<Ct className="thumbnail-container image-container"onClick={d||o?a:l}$isStudent={!!d}onMouseEnter={O}onMouseLeave={F}><It>{(!$||!S)&&<R/>}{n&&c&&$&&<N/>}</It>{(t||d)&&<$t $isStudent={!!d}><J level={3}levelDisplay={3}margin="0px 0px 8px">{(d==null?void 0:d.studentName)||t}</J>{d&&<Et openModal={l}title={d.artWorkTitle}educationLevel={d.educationLevel}schoolName={d.schoolName}isVotingOpen={d.isVotingOpen}/>}{T&&C?<Nt tags={C}/>:null}</$t>}</Ct>}</>};import{useCallback as ci,useEffect as Ge,useState as gi}from"react";import mi from"react-dom";import{disableBodyScroll as fi}from"@msgtechnology/ui";import{styled as Pt}from"styled-components";var Ot=Pt.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); //rgba(var(--black-rgba), 0.8);
  backdrop-filter: blur(8px);
  overflow: auto;

  .modal-dialog {
    width: auto;
    height: 100%;
    display: flex;
    padding: 15px;
  }

  .modal-content {
    position: relative;
    padding: 24px; //var(--spacing-3) var(--spacing-3);
    margin: auto;
    background-color: #1b1b1b; //var(--gray-900);
    border-radius: 8px; //var(--spacing-1);

    &.modal-content--wide {
      //Resizes the Gallery modal contents while maintaining aspect ratio when the viewport gets smaller
      width: 134vh;
      max-width: 1280px;
      padding: 0;
    }

    &.modal-content--extra-wide {
      width: 160vh;
      max-width: 1267px;
      padding: 0;

      @media (max-width: 1127px) {
        width: 100%;
      }
    }

    // Assumes button is at bottom of modal
    button:last-child {
      @media (max-width: 767px) {
        // required to prevent iOS Chrome bottom bar from overlapping
        // do not change unless specifically required
        margin-bottom: 32px; //var(--spacing-4);
      }
    }
  }
`,Se=Pt.button`
  border: none;
  position: absolute;
  padding: 12px;
  z-index: 10000;
  cursor: pointer;
  border-radius: 50%;
  background: transparent;
  color: #fff; //var(--white);
  top: 6px;
  right: 6px;
  width: 40px;
  height: 40px;
  transition: opacity 0.8s linear;

  &:hover {
    background: linear-gradient(
      250deg,
      #fff 19%,
      #c6c6c6 75%
    ); //linear-gradient(250deg, var(--white) 19%, var(--gray-200) 75%);

    svg path {
      fill: #000;
      opacity: 0.9;
    }
  }

  svg {
    width: 16px;
    height: 16px;

    @media (max-width: 767px) {
      width: 12px;
      height: 12px;
    }
  }

  @media (max-width: 767px) {
    width: 32px;
    height: 32px;
    padding: 10px;
  }
`;var Ce=()=><svg width="13"height="12"viewBox="0 0 13 12"fill="none"xmlns="http://www.w3.org/2000/svg"><line x1="1.35355"y1="0.646447"x2="11.9602"y2="11.253"stroke="#757575"/><line y1="-0.5"x2="15"y2="-0.5"transform="matrix(-0.707107 0.707107 0.707107 0.707107 12 1)"stroke="#757575"/></svg>;var $e=({isOpen:e,handleModalClose:t,children:o,closeOnOutsideClick:a=!0,contentWidth:l})=>{let[p,s]=gi(!1);Ge(()=>{s(!0)},[]),Ge(()=>{fi(e)},[e]);let n=ci(C=>{let{key:T}=C;T==="Escape"&&e&&t&&t()},[e]);Ge(()=>(window.addEventListener("keydown",n),()=>window.removeEventListener("keydown",n)),[n]);let c=C=>{C.target===C.currentTarget&&a&&t()},d=e?<Ot><div className="modal-dialog"role="document"onClick={c}><div className={`modal-content modal-content--${l}`}><Se onClick={t}><Ce/></Se>{o}</div></div></Ot>:null;if(p){let C=document.getElementById("root-modal");return C?mi.createPortal(d,C):null}else return null};import{styled as le}from"styled-components";var Ft=le.div`
  background-color: #1b1b1b; //var(--gray-900);
  border-radius: 8px; //var(--spacing-1);
  padding: 16px; //var(--spacing-2);

  .level-1 {
    font-size: 18px;
    font-weight: 350; //var(--font-weight-light);
    margin-bottom: 16px; //var(--spacing-2);
    padding-right: 40px; //var(--spacing-5);

    @media (max-width: 767px) {
      font-size: 16px; //var(--font-size-h5-mobile);
    }
  }
`,Ht=le.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  width: 100%;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 12px;
  }

  video::-webkit-media-controls-panel {
    display: none;
  }

  &:hover {
    video::-webkit-media-controls-panel {
      display: flex;
    }
  }
`,Gt=le.div`
  background-color: #1b1b1b; //var(--gray-900);
  border-radius: 8px; //var(--spacing-1);
  padding: 42px 24px 24px 24px; //var(--spacing-2);
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 767px) {
    padding: 42px 16px;
  }
`,Wt=le.div`
  display: flex;
  flex-direction: row;
  gap: 24px;

  .vimeo-container {
    flex-grow: 2;
    flex-shrink: 0;
    flex-basis: 445px;
    display: flex;
    flex-direction: column;
    gap: 24px;

    @media (max-width: 767px) {
      width: 100%;
      flex-basis: 0;
      display: flex;
      flex-direction: column-reverse;
      padding-bottom: 24px;
      border-bottom: 1px solid #474747;
    }

    @media (min-width: 1129px) {
      flex-grow: 2.5;
    }
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`,_t=le.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .level-3 {
    font-size: 32px;
    font-weight: 350;
    line-height: 120%;
    margin: 0;

    @media (max-width: 767px) {
      font-size: 20px;
      line-height: 100%;
    }
  }

  div {
    font-size: 18px;
    font-weight: 350;
    line-height: 150%;

    @media (max-width: 767px) {
      font-size: 14px;
      font-weight: 350;
      line-height: 150%;
    }
  }
`,vr=le.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  color: #fff;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;import{useState as wi}from"react";import{useCallback as ui,useEffect as je,useState as xi}from"react";import hi from"react-dom";import{disableBodyScroll as yi}from"@msgtechnology/ui";var Zt=()=><svg xmlns="http://www.w3.org/2000/svg"width="54"height="55"viewBox="0 0 54 55"fill="none"><rect x="0.5"y="0.999756"width="53"height="53"rx="26.5"stroke="#036471"/><path d="M22 28.8634L25.7333 32.4998L36 22.4998"stroke="#20FFFF"strokeWidth="2"strokeLinecap="round"/></svg>;import{styled as se}from"styled-components";var Ut=se.div`
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8); //rgba(var(--black-rgba), 0.8);
  backdrop-filter: blur(8px);
`,Yt=se.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`,Kt=se.div`
  position: relative;
  padding: ${({$padding:e})=>e||"62px 16px 24px"};
  width: 404px;
  background-color: #1b1b1b;
  backdrop-filter: blur(4px);
  border-radius: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${({$gap:e})=>e||"24px"};
`,Xt=se.div`
  margin: auto;
  @media (min-width: 768px) {
    width: ${({$widthDesktop:e})=>e||"278px"};
  }

  @media (max-width: 767px) {
    width: ${({$widthMobile:e})=>e||"256px"};
  }
`,Qt=se.div`
  display: flex;
  margin: auto;
  gap: 8px;
  flex-direction: row;
  align-items: top;
`;var We=se.button`
  border-radius: 40px;
  font-size: 14px;
  font-weight: 300;
  line-height: normal;
  letter-spacing: 0.7px;
  color: ${e=>e.$buttonType===1?"#e2e2e2":"#000"};
  background-color: ${e=>e.$buttonType===1?"#1b1b1b":"linear-gradient(250deg, #c6c6c6 19%, #fff 75%)"};
  border: 1px solid #e2e2e2;
  transition: all 0.4s, border 0.2s;
  padding-top: 8px;
  padding-bottom: 8px;
  width: 134px;
  margin-bottom: 8px;

  &:hover {
    color: #000;
    border: 1px solid transparent;
    background: ${e=>(e.$buttonType===1,"linear-gradient(250deg, #fff 19%, #c6c6c6 75%)")};
    cursor: pointer;
  }

  @media (max-width: 767px) {
    width: 124px;
    font-size: 12px;
  }
`;var Jt=()=><svg data-icon="warning"width="43"height="40"viewBox="0 0 43 40"fill="none"><g clipPath="url(#clip0_6892_104560)"><path d="M27.2282 5.03747L39.8465 28.707C42.3322 33.3697 38.9533 39 33.6694 39H9.03377C3.81126 39 0.427882 33.4877 2.79216 28.831L14.8095 5.16152C17.374 0.110509 24.5634 0.0386944 27.2282 5.03747Z"fill="#FFD028"fillOpacity="0.2"stroke="#FFE27D"strokeWidth="2"/><path d="M20.2428 15.72H22.7628L22.4828 25.02H20.5228L20.2428 15.72ZM21.5028 26.44C22.3028 26.44 22.8828 27.04 22.8828 27.82C22.8828 28.6 22.3028 29.2 21.5028 29.2C20.7228 29.2 20.1228 28.6 20.1228 27.82C20.1228 27.04 20.7228 26.44 21.5028 26.44Z"fill="#FFE27D"/></g><defs><clipPath id="clip0_6892_104560"><rect width="43"height="40"fill="white"/></clipPath></defs></svg>;var eo=(l=>(l[l.WARNING=1]="WARNING",l[l.INFO=2]="INFO",l[l.ERROR=3]="ERROR",l[l.SUCCESS=4]="SUCCESS",l))(eo||{}),bi=({isOpen:e,handleModalClose:t,children:o,closeOnOutsideClick:a=!0,type:l=1,closeBtnText:p="Close",actionButtonText:s="Action",actionButtonCallback:n=()=>null,shareButton:c,modalCloseAction:d,contentPadding:C,contentGap:T,widthDesktop:$,widthMobile:k})=>{let[S,V]=xi(!1);je(()=>{V(!0)},[]),je(()=>{yi(e)},[e]);let D=ui(E=>{let{key:B}=E;B==="Escape"&&t&&t()},[]);if(je(()=>(window.addEventListener("keydown",D),()=>window.removeEventListener("keydown",D)),[D]),!l)return<></>;let O=E=>{E.target===E.currentTarget&&a&&t()},F=E=>{t(),d&&d()},N=E=>{n(),setTimeout(()=>{t()},100)},R=()=>{switch(l){case 1:return<Jt/>;case 4:return<Zt/>;default:return<></>}},f=e?<Ut><Yt role="document"onClick={O}><Kt $type={l}$padding={C}$gap={T}><Se onClick={t}data-testid="modal-close-icon-btn"><Ce/></Se>{R()}<Xt $widthDesktop={$}$widthMobile={k}>{o}</Xt><Qt>{c}<We $buttonType={1}onClick={F}>{p}</We>{l===1&&<We $buttonType={2}onClick={N}>{s}</We>}</Qt></Kt></Yt></Ut>:null;return S?hi.createPortal(f,document.getElementById("root-modal")):null},So=bi;import{useState as Ie}from"react";import{styled as de}from"styled-components";var Co=de.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  flex-basis: 205px;
  flex-shrink: 2;
  flex-grow: 1;
  font-size: 20px;
  line-height: 120%;
  font-weight: 600;

  div {
    text-align: left;
    width: 100%;

    @media (min-width: 768px) {
      max-width: 332px;
    }

    @media (min-width: 321px) and (max-width: 767px) {
      text-align: center;
    }
  }

  p {
    font-size: 14px;
    font-weight: 350;

    @media (max-width: 767px) {
      margin: 0;
    }
  }

  @media (max-width: 767px) {
    font-size: 18px;
    line-height: 100%;
  }
`,$o=de.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;

  @media (min-width: 768px) {
    max-width: 332px;
  }

  input {
    width: 100%;
  }

  button {
    width: 100%;
  }
`,_e=de.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  input {
    color: ${e=>e.$hasError?"#f52500":"#fff"};
    border-radius: 8px;
    outline: none;
    border: ${e=>e.$hasError?"1px solid #f52500":"1px solid #757575"};
    font-size: 14px;
    background-color: #1b1b1b;
    padding: 10px;
    position: relative;
    display: flex;
    font-size: 18px;
    cursor: auto;

    &::placeholder {
      color: ${e=>e.$hasError?"#f52500":"#ababab"};
    }

    &:focus {
      border-color: ${e=>e.$hasError?"#f52500":"#fff"};

      &::placeholder {
        color: transparent;
      }
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
      left: 14px;
      top: 0;
      font-size: 12px;
      font-weight: 300;
      background-color: #1b1b1b;
      padding-left: 4px;
      padding-right: 4px;
      color: ${e=>e.$hasError?"#f52500":"#fff"};
      display: flex;
    }

    + label {
      position: absolute;
      transform: translateY(-50%);
      left: 14px;
      top: 25%;
      transition: all 0.25s ease-out;
      pointer-events: none;
      color: transparent;
    }
  }

  &:nth-child(2) {
    padding-bottom: 8px;

    @media (max-width: 767px) {
      padding-bottom: 0;
    }
  }
`,Io=de.button`
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 48px;
  border: none;
  color: #000;
  background: linear-gradient(251deg, #20ffff 19.17%, #05c3dd 75.2%);
  letter-spacing: 0.9px;
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;

  &:hover {
    background: linear-gradient(248deg, #05c3dd 27.85%, #20ffff 81.23%);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.5);
  }

  &:disabled {
    background: #5e5e5e;
    color: #ababab;
  }
`,Mo=de.button`
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 48px;
  border: 1px solid #e2e2e2;
  background: transparent;
  color: #fff;
  letter-spacing: 0.9px;
  font-size: 18px;
  font-weight: 300;
  cursor: pointer;
  margin-bottom: 8px;

  &:hover {
    border: 1px solid linear-gradient(248deg, #fff 17.66%, #c6c6c6 71.37%);
    background: linear-gradient(248deg, #fff 17.66%, #c6c6c6 71.37%);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.5);
    color: #000;
  }

  @media (max-width: 767px) {
    margin-bottom: 0px;
  }
`,Ze=de.div`
  color: #f52500;
  font-size: 14px;
  font-weight: 350;
  line-height: 150%;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-start;
  justify-content: flex-start;

  span {
    text-align: left;
  }
`;var Ue=()=><svg xmlns="http://www.w3.org/2000/svg"width="24"height="25"viewBox="0 0 24 25"fill="none"><path d="M2.08057 21.025L11.9998 3.925L21.9191 21.025H2.08057ZM3.98634 19.9308H20.0133L11.9998 6.11345L3.98634 19.9308ZM12.0639 18.4769C12.2456 18.4769 12.3998 18.412 12.5267 18.2823C12.6537 18.1525 12.7171 17.9993 12.7171 17.8227C12.7171 17.646 12.6521 17.4901 12.522 17.3548C12.3919 17.2196 12.2361 17.1519 12.0545 17.1519C11.8729 17.1519 11.7171 17.2193 11.5871 17.3539C11.4571 17.4886 11.3921 17.6478 11.3921 17.8317C11.3921 18.0084 11.4587 18.1601 11.5918 18.2869C11.725 18.4136 11.8823 18.4769 12.0639 18.4769ZM11.5075 16.0808H12.6017V10.7385H11.5075V16.0808Z"fill="#F52500"/></svg>;var Vo=({closeModal:e,openConfirmationModal:t,submitVote:o,videoVoteInfo:a,reminder:l,disclaimer:p,isVotingOpen:s})=>{let[n,c]=Ie(""),[d,C]=Ie(""),[T,$]=Ie(!1),[k,S]=Ie({}),V="^[a-zA-Z0-9_+&*-]+(?:\\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$",D="[a-zA-Z]",O="This field is required!",F=f=>{let E={},B=new RegExp(D),G=new RegExp(V);return f.currentTarget.elements.name.value===""?E.name=O:B.test(f.currentTarget.elements.name.value)||(E.name="This name is invalid!"),f.currentTarget.elements.email.value===""?E.email=O:G.test(f.currentTarget.elements.email.value)||(E.email="This email is invalid!"),E},N=f=>{let E={};f.message==="This email has already voted for this cohort!"||(E.name=f.message),E.email=f.message,S(E)},R=f=>ee(void 0,null,function*(){f.preventDefault(),$(!0);let E=F(f);if(!E||Object.keys(E).length===0)try{let B={name:n,email:d,videoId:a.id,videoEducationLevel:a.educationLevel};yield o(B),$(!1),e(f),t()}catch(B){console.error(B),$(!1),N(B)}else S(E),$(!1)});return<Co><div>Cast your vote for this design!{l?<p>{l}</p>:null}</div><$o noValidate onSubmit={R}><_e $hasError={!!k.name}><input type="text"placeholder="Your Name *"id="name"value={n}onChange={f=>c(f.target.value)}tabIndex={0}/><label htmlFor="name">Your Name *</label>{k&&k.name?<Ze><Ue/><span>{k.name}</span></Ze>:null}</_e><_e $hasError={!!k.email}><input type="email"placeholder="Your Email *"id="email"value={d}onChange={f=>C(f.target.value)}tabIndex={0}/><label htmlFor="email">Your Email *</label>{k&&k.email?<Ze><Ue/><span>{k.email}</span></Ze>:null}</_e><Io type="submit"disabled={T}tabIndex={0}>Submit</Io><Mo onClick={e}tabIndex={0}>Cancel</Mo>{p?<p>{p}</p>:null}</$o></Co>};var Eo=({videoVoteInfo:e,children:t,handleModalClose:o,modalIsOpen:a,submitVote:l,shareButton:p,reminder:s,disclaimer:n,confirmationModalCloseAction:c,isVotingOpen:d,votingButtons:C})=>{let[T,$]=wi(!1);return<><$e handleModalClose={o}isOpen={a}contentWidth="extra-wide"><Gt><Wt>{t}<Vo videoVoteInfo={e}closeModal={o}openConfirmationModal={()=>$(!0)}submitVote={l}reminder={s}disclaimer={n}isVotingOpen={d}/></Wt></Gt></$e><So handleModalClose={()=>$(!1)}modalCloseAction={c}isOpen={T}type={4}closeOnOutsideClick={!0}closeBtnText="Back to gallery"shareButton={p}contentPadding="62px 12px 24px"contentGap="unset"widthDesktop="unset"widthMobile="unset">{C}</So></>};var Ao=({id:e,video:t,thumbnail:o,autoplay:a=!1,displayThumbnail:l=!1,nextImage:p,videoDescription:s,voteDetails:n,useDetailsSlug:c,goToDetailsPage:d,shareButton:C,applyActiveVideoModal:T,removeActiveVideoModal:$,activeVideoModal:k,enableVideoHover:S,showTags:V,votingButtons:D})=>{let[O,F]=Do(!1),N=To(null),R=To(null),f=Ci({ref:R}),{isBreakpoint:E}=ki("md","<"),B=()=>{var I;(I=N.current)==null||I.pause()};Me(()=>{var I,Z;if(t.url&&f){let{isIntersecting:ge}=f,fe=((I=N.current)==null?void 0:I.readyState)===4;ge&&!fe&&((Z=N.current)==null||Z.load())}},[f==null?void 0:f.isIntersecting,t.url]),Me(()=>{var I;if(f){let{isIntersecting:Z}=f,ge=(I=N.current)==null?void 0:I.paused;!Z&&!ge&&B()}},[f==null?void 0:f.isIntersecting]),Me(()=>{F(k===e?I=>I||!0:I=>I&&!1)},[k]);let G=()=>{F(!1),$&&$()},Le=I=>{I.stopPropagation(),!(n&&!n.isVotingOpen())&&(F(!0),T&&T(e))},[W,j]=Do(),te=.5625,ce=60,oe=vi(()=>{let I=(window.innerWidth-ce)*te;return j(I)},[]);Me(()=>{window.addEventListener("resize",oe);let I=(window.innerWidth-ce)*te;return j(I),()=>{window.removeEventListener("resize",oe)}},[W,oe]);let _=(I,Z)=><><div className="vimeo-container"ref={R}><Ht className="video-container"><video id={e}autoPlay={Z}loop={!1}muted playsInline={!0}ref={N}poster={t.posterImage}width="100%"height={W}controls preload="none"><source src={I}type="video/mp4"/>Your browser does not support the video tag.</video></Ht>{n?<_t><J level={E?3:2}levelDisplay={3}>{n.studentName}</J><div>{ye[n.educationLevel]}, {n.schoolName}<br/><span style={{fontStyle:"italic"}}>{n.artWorkTitle}</span></div></_t>:null}</div></>,me={"@context":"http://schema.org","@type":"VideoObject",name:n?n.artWorkTitle:t.title,description:n?n.artWorkTitle:s||t.title,thumbnailUrl:o,uploadDate:t.uploadDate?t.uploadDate:n==null?void 0:n.createdAt,contentUrl:t.url};return<><Si data={me}/>{l&&t.posterImage?<><Lt videoTitle={t.title}posterImage={t.posterImage}useDetailsSlug={c}onClick={d}openModal={Le}nextImage={p||void 0}thumbnail={o}enableVideoHover={S}loDefVideo={t.loDefVideo}voteDetails={n}tags={t.tags}showTags={V}/>{n?<Eo handleModalClose={G}modalIsOpen={O}submitVote={n.submitVote}videoVoteInfo={{id:e,educationLevel:n.educationLevel}}shareButton={C}reminder={n.reminder}disclaimer={n.disclaimer}isVotingOpen={n.isVotingOpen}votingButtons={D}>{_(t.url,a)}</Eo>:t.url?<$e handleModalClose={G}isOpen={O||k===e}contentWidth="extra-wide"><Ft className="modal-container"><J level={3}levelDisplay={1}>{t.title}</J>{_(t.url,a)}</Ft></$e>:null}</>:t.url&&_(t.url,a)}</>};import{useEffect as Re,useState as Be,useRef as Fi}from"react";import{useEffect as $i,useState as Ii}from"react";import{styled as No}from"styled-components";var Ro=No.nav`
  ul {
    list-style: none;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 0;
    margin: 0;

    //Styling that applies to the Galaxy Fold only
    @media (max-width: 320px) {
      gap: 10px;
    }
  }

  li {
    display: inline-block;
  }
`,Ve=No.button`
  cursor: pointer;
  border-radius: 50%;
  border-color: ${e=>e.$isSelected?"#fff":"#ababab"};
  border-style: solid;
  border-width: 2px;
  width: 48px; // var(--spacing-6);
  height: 48px; //var(--spacing-6);
  padding: 5px;
  background-color: ${e=>e.$isSelected?"#fff":"transparent"};
  color: ${e=>e.$isSelected?"#000":"#fff"};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 11px;
  letter-spacing: 2.2px;

  //Styling that applies to the Galaxy Fold only
  @media (max-width: 320px) {
    width: 40px; //var(--spacing-5);
    height: 40px; //var(--spacing-5);
  }

  &:hover {
    background-color: #fff; // var(--gray-300);
    color: #000; //var(--black);
    border-color: #fff; //var(--gray-300);

    svg path {
      fill: #000;
    }
  }
`;var Bo=()=><svg xmlns="http://www.w3.org/2000/svg"width="11"height="18"viewBox="0 0 11 18"fill="none"><path d="M10.1387 8.42893C10.1223 8.25438 10.0462 8.08922 9.9212 7.95724L2.73709 0.305681C2.58362 0.131572 2.35983 0.0223707 2.11726 0.00304238C1.87468 -0.016143 1.63397 0.0559828 1.45044 0.203264C1.26675 0.350546 1.15587 0.560144 1.14319 0.784148C1.1305 1.00815 1.21711 1.22729 1.3831 1.39129L8.05526 8.5L1.3831 15.6087C1.21711 15.7727 1.1305 15.9918 1.14319 16.2159C1.15587 16.4399 1.26675 16.6495 1.45044 16.7967C1.63398 16.944 1.87467 17.0161 2.11726 16.997C2.35983 16.9776 2.58362 16.8684 2.73709 16.6943L9.9212 9.04276C10.0809 8.8737 10.1594 8.65213 10.1387 8.42882L10.1387 8.42893Z"fill="white"/></svg>;var Lo=()=><svg xmlns="http://www.w3.org/2000/svg"width="11"height="18"viewBox="0 0 11 18"fill="none"><path d="M0.861285 8.42893C0.877729 8.25438 0.953837 8.08922 1.0788 7.95724L8.26291 0.305681C8.41638 0.131572 8.64017 0.0223707 8.88274 0.00304238C9.12532 -0.016143 9.36603 0.0559828 9.54956 0.203264C9.73325 0.350546 9.84413 0.560144 9.85681 0.784148C9.8695 1.00815 9.78289 1.22729 9.6169 1.39129L2.94474 8.5L9.6169 15.6087C9.78289 15.7727 9.8695 15.9918 9.85681 16.2159C9.84413 16.4399 9.73325 16.6495 9.54956 16.7967C9.36602 16.944 9.12533 17.0161 8.88274 16.997C8.64017 16.9776 8.41638 16.8684 8.26291 16.6943L1.0788 9.04276C0.919071 8.8737 0.840615 8.65213 0.861285 8.42882L0.861285 8.42893Z"fill="white"/></svg>;var Po=({currentPage:e,onPageChange:t,totalPages:o,onNext:a,onPrevious:l})=>{let[p,s]=Ii([]),n=Array.from({length:o},(d,C)=>C+1);$i(()=>{if(o>3){let d=[];if(e===1)d=n.slice(0,4);else{if(e>1&&e<=3){if(p.length===3&&p.includes(e))return;d=n.slice(0,3)}if(e>3)if(e===n[n.length-1])d=n.slice(e-4,e);else{if(p.length===3&&p.includes(e))return;d=n.slice(e-3,e)}}s(d)}else s(n)},[e]);let c=d=>{let C=d===e;return<li key={d}><Ve $isSelected={C}onClick={t}value={d}>{d}</Ve></li>};return<Ro role="navigation"><ul>{e>1?<li><Ve onClick={l}><Lo/></Ve></li>:""}{p.map(d=>c(d))}{e<n[n.length-1]?<li><Ve onClick={a}><Bo/></Ve></li>:""}</ul></Ro>};import{useWindowSize as Ti}from"@msgtechnology/ui";import Mi,{useState as Ho,useRef as Vi}from"react";import{useOutsideClick as Ei}from"@msgtechnology/ui";import{styled as Ee}from"styled-components";var Oo=Ee.div`
  line-height: 150%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  position: relative;

  @media (max-width: 767px) {
    width: 100%;
    margin: auto;
    align-items: center;
  }
`,De=Ee.button`
  display: flex;
  padding: 8px 16px;
  width: 100%;
  min-width: 200px;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  background-color: ${e=>e.$isOpen?"#000":"rgba(0, 0, 0, 0.5)"};
  border: ${e=>e.$isOpen?"2px solid #fff":"1px solid #757575"};
  color: ${e=>e.$isOpen?"#fff":"#ababab"};
  cursor: pointer;
  font-size: 16px;
  font-weight: 350;
  line-height: 150%;
  margin-top: ${e=>e.$isOpen?"0px":"1px"};
  margin-bottom: ${e=>e.$isOpen?"0px":"1px"};

  @media (max-width: 320px) {
    width: 100%;
  }

  &:hover {
    background-color: #000;
    color: ${e=>e.$isDisabled?"#ababab":"rgba(255, 255, 255, 1)"};

    svg g path {
      fill: ${e=>e.$isDisabled?"#ababab":"#fff"};
    }
  }

  svg g path {
    fill: ${e=>e.$isOpen?"#fff":"#ababab"};
  }

  div {
    @media (min-width: 768px) {
      padding-right: 16px;
    }
  }
`,Fo=Ee.ul`
  margin: 0px;
  padding: 8px 0px;
  flex-direction: column;
  min-width: 100%;
  align-items: flex-end;
  border-radius: 8px;
  background: #000;
  box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.2);
  position: absolute;
  z-index: 8999;
  display: ${e=>e.$isOpen?"flex":"none"};
  top: 100%;

  @media (max-width: 767px) {
    width: 100%;
  }
`,Te=Ee.li`
  display: flex;
  padding: 8px 16px;
  padding-right: 42px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  cursor: pointer;
  color: ${e=>e.$isSelected?"#757575":"#fff"};
  list-style: none;
  position: relative;
  font-size: 18px;
  gap: 8px;
  font-weight: 350;
  width: 100%;
  white-space: ${e=>e.$whiteSpace?e.$whiteSpace:"normal"};

  &:hover {
    background: #fff;
    color: #000;
  }
`;var Ae=()=><svg width="16"height="16"viewBox="0 0 16 16"fill="none"xmlns="http://www.w3.org/2000/svg"><g id="Foundations/Iconography"><path id="Vector"d="M1.94338 4.09888L14.0566 4.09888C14.8954 4.09888 15.3155 5.11299 14.7224 5.70608L8.66573 11.7627C8.29808 12.1304 7.70194 12.1304 7.33429 11.7627L1.27766 5.70608C0.684523 5.11299 1.10461 4.09888 1.94338 4.09888Z"fill="#ABABAB"/></g></svg>;var Ne=({onChange:e,options:t,current:o,menuHeading:a,showMenuHeadingInSelectedState:l=!1,disabled:p=!1})=>{let[s,n]=Ho(!1),[c,d]=Ho(o>=0?o:-1),C=Vi(null),T=()=>{p||n(!s)},$=S=>ee(void 0,null,function*(){p||(d(S),n(!1),yield e(S))});Ei(C,()=>{p||n(!1)});let k=S=>{let V=t[S];return V==="Elementary_School"?"Elementary":V.replace("_"," ")};return<Oo ref={C}><De $isOpen={s}$isDisabled={p}onClick={T}tabIndex={0}disabled={p}><div>{c<0?a:l?`${a}: ${k(c)}`:`${k(c)}`}</div><Ae/></De><Fo $isOpen={s}role="menu">{t.map((S,V)=>(S==="Elementary_School"&&(S="Elementary"),<Mi.Fragment key={S}><Te role="menuItem"$isSelected={c===V}$whiteSpace="nowrap"onClick={()=>$(V)}tabIndex={p?-1:0}aria-disabled={p}>{S.replace("_"," ")}</Te></Mi.Fragment>))}</Fo></Oo>};import{styled as Wo}from"styled-components";var z={DEFAULT:"default",DROPDOWN:"dropdown"},Go={UPPER:"upper",LOWER:"lower"};var _o=Wo.div`
  width: 100%;
  text-align: center;
  background: transparent;
  justify-content: ${e=>e.$type===z.DROPDOWN?"space-between":"center"};
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  border-bottom: ${e=>e.$type===z.DROPDOWN?"1px solid rgba(255, 255, 255, 0.4)":"1px solid #474747"};
  line-height: ${e=>e.$type===z.DROPDOWN?"12px":"initial"};

  @media (min-width: 768px) {
    margin-top: ${e=>e.$type===z.DROPDOWN?"0px":"-40px"};
  }
  gap: ${e=>e.$type===z.DROPDOWN?"initial":"48px"};
`,Zo=Wo.span`
  padding: 16px 8px;
  gap: ${e=>e.$type===z.DROPDOWN&&!e.$isActive?"initial":"16px"};
  display: inline-flex;
  flex-direction: column;
  cursor: pointer;
  white-space: nowrap;
  font-size: ${e=>e.$type===z.DROPDOWN?"12px":"22px"};
  font-weight: ${e=>e.$type===z.DROPDOWN||e.$isActive?"600":"350"};
  color: ${e=>e.$isActive?"#fff":e.$type==="dropdown"?"rgba(255, 255, 255, 0.8)":"#c6c6c6"};
  letter-spacing: ${e=>e.$type===z.DROPDOWN?"0.2em":"initial"};
  border-bottom: ${e=>e.$isActive?"2px solid #06eaff":"unset"};

  &:hover {
    border-bottom: ${e=>e.$isActive?"2px solid #06eaff":"2px solid #036471"};
  }

  @media (max-width: 768px) {
    padding: 16px 8px;
    font-size: ${e=>e.$type===z.DROPDOWN?"12px":"18px"};
  }
`;import{useCallback as Di}from"react";var Uo=({activeIndex:e,setActiveIndex:t,labels:o,casing:a,type:l=z.DEFAULT})=>{let p=Di(s=>{let{key:n}=s;if(n===" "||n==="Spacebar"){s.preventDefault();let c=Number(s.target.getAttribute("id"));t(c)}},[]);return<>{o.length&&<_o $type={l}>{o.map((s,n)=>{let c=e===n;return s==="Elementary_School"&&(s="Elementary"),<Zo id={n.toString()}key={n}$type={l}$isActive={c}onClick={()=>{t(n)}}tabIndex={0}onKeyDown={p}>{a&&a===Go.UPPER?s.replaceAll("_"," ").toUpperCase():s.replaceAll("_"," ")}</Zo>})}</_o>}</>};var Ai=({filterByTab:e,tabLabels:t,activeTabIndex:o})=>{let{isBreakpoint:a}=Ti("md","<");return a?<Ne key={o+t[o]}onChange={e}options={t!=null&&t.length?t:[]}current={o}menuHeading="Select student group"/>:<Uo labels={t!=null&&t.length?t:[]}activeIndex={o}setActiveIndex={e}/>},Yo=Ai;import{styled as pe}from"styled-components";var Ko=pe.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (min-width: 768px) {
    gap: 24px;
  }

  @media (min-width: 1440px) {
    gap: 40px;
  }
`,Xo=pe.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
`,Qo=pe.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;

  @media (max-width: 767px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }
`,Jo=pe.div`
  position: absolute;
  top: 65px;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.7);

  @media (max-width: 767px) {
     top: 160px;
  }
`,Sn=pe.div`
  display: flex;
  flex-direction: column;
  padding: 5% 20%;
  gap: 24px;
`,Cn=pe.button`
  height: 33px;
  width: 110px;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(226, 226, 226, 1);
  border-radius: 40px;
  color: white;
  margin: 0 auto;

  &:hover {
    background: linear-gradient(248.24deg, #FFFFFF 17.66%, #C6C6C6 71.37%);
    color: black;
    cursor: pointer;
  }

`;import Ri,{useState as Rn,useRef as Bi}from"react";import{useOutsideClick as Li}from"@msgtechnology/ui";import{styled as Y}from"styled-components";var $n=Y.div`
  gap: 8px;
  line-height: 150%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;

  right: 16px;

  @media (max-width: 767px) {
    width: 100%;
    justify-content: center;
    align-items: center;
  }
`,In=Y.div`
  position: absolute;
  z-index: 8999;
  width: 390px;
  top: 100%;
  background: #000;
  display: ${e=>e.$isOpen?"initial":"none"};
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 767px) {
    width: 100%;
    margin: auto;
    max-width: calc(100vw - 47px);
    top: 86px;
  }

  @media (hover: none) and (max-width: 767px) {
    max-width: calc(100vw - 32px);
  }
`,Mn=Y.ul`
  width: 390px;
  max-height: 350px;
  overflow-y: auto;
  scrollbar-color: #5e5e5e #000;
  scrollbar-width: thin;
  padding: 8px 0px;
  margin: 0;
  border-radius: 8px;

  @media (max-width: 767px) {
    width: 100%;
  }
`,Vn=Y.input.attrs({type:"checkbox"})`
  //Hide built-in checkbox
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;

  //custom checkmark
  &:checked + label::after {
    content: '';
    display: block;
    position: absolute;
    top: 40%;
    left: 8px; //var(--spacing-1);
    transform: translateY(-50%) rotate(45deg);
    width: 8px; //var(--spacing-1);
    height: 20px; //var(--spacing-2);
    border: solid #000;
    border-width: 0 2px 2px 0;
  }

  &:checked + label::before {
    background-color: #fff; //var(--white);
    border-color: #fff; //var(--white);
  }

  &:hover {
    &:checked + label::before {
      border-color: #757575;
    }
  }
`,En=Y.label`
  position: relative;
  cursor: pointer;
  gap: 8px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  width: 100%;
  text-transform: capitalize;

  //custom checkbox
  &::before {
    content: '';
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
    background-color: rgba(#000, 0.8); //rgba(var(--black-rgba), 0.8);
    border: 1px solid #757575; //var(--gray-500);
    border-radius: 8px; //var(--spacing-1);
    width: 24px;
    min-width: 24px;
    height: 24px;
    min-height: 24px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    margin-right: 8px;
  }
`,Dn=Y.div`
  display: flex;
  width: 100%;
  justify-self: flex-end;

  @media (max-width: 767px) {
    width: 100%;
  }
`,Tn=Y.div`
  background-color: #000;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #5e5e5e;
  border-radius: 0px 0px 0px 8px;

  &:hover {
    background-color: ${e=>e.$disabled?"#000":"#1B1B1B"};
  }

  button {
    color: ${e=>e.$disabled?"#5e5e5e":"#c6c6c6"};
    border: none;
    display: flex;
    justify-content: space-evenly;
    padding: 8px 16px;
    align-items: center;
    background-color: transparent;
    font-size: 14px;
    font-weight: 300;
    cursor: pointer;
    letter-spacing: 0.7px;
    line-height: normal;
    width: 100%;
    border-radius: 0px 0px 0px 8px;

    &:hover {
      color: ${e=>e.$disabled?"#5e5e5e":"#fff"};
    }
  }
`,An=Y.div`
  background: linear-gradient(248.24deg, #ffffff 17.66%, #c6c6c6 71.37%);
  border-radius: 0px 0px 8px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #5e5e5e;

  button {
    color: #000;
    border: none;
    display: flex;
    justify-content: space-evenly;
    padding: 8px 16px;
    align-items: center;
    background-color: transparent;
    font-size: 14px;
    font-weight: 300;
    cursor: pointer;
    letter-spacing: 0.7px;
    line-height: normal;
    width: 100%;
    border-radius: 0px 0px 8px 0px;

    &:hover {
      color: #000;
    }
  }

  &:hover {
    background: linear-gradient(248deg, #c6c6c6 17.66%, #fff 71.37%);
  }
`,Nn=Y.div`
  padding: 16px 42px 8px 16px;
  gap: 4px;
  text-transform: uppercase;
  color: #ABABAB;
`;import{useState as Ni}from"react";var Ye=({item:e,isChecked:t,updateFilterList:o})=>{let[a,l]=Ni(t),p=s=>{l(!a),o(e)};return<Te key={`${e}`}><Vn type="checkbox"id={`${e}`}name="filter"onChange={p}checked={t}value={e}autoComplete="off"/><En role="menuItem"htmlFor={`${e}`}tabIndex={0}>{e}</En></Te>};var Bn=({onChange:e,options:t,menuHeading:o,current:a=[]})=>{let[l,p]=Rn(!1),[s,n]=Rn(a),c=Bi(null),d=()=>p(!l),C=S=>{let V;s.includes(S)?V=s.filter(D=>D!==S):V=[...s,S],n(V)};Li(c,()=>{n(a),p(!1)});let T=()=>s.length?`${o} (${s.length})`:`${o}`,$=()=>{n([])},k=()=>{p(!1),e(s)};return<$n ref={c}><De $isOpen={l}onClick={d}tabIndex={0}><div>{T()}</div><Ae/></De><In $isOpen={l}><Mn role="menu">{t.map(S=>typeof S=="string"?<Ye item={S}isChecked={s.includes(S)}updateFilterList={C}key={S}/>:<Ri.Fragment key={S.categoryName||"default_key"}>{S.tagNames?<><Nn>{S.categoryName}</Nn>{S.tagNames.map(V=><Ye item={V}isChecked={s.includes(V)}updateFilterList={C}key={V}/>)}</>:null}</Ri.Fragment>)}</Mn><Dn style={{display:"flex",flexDirection:"row",justifyContent:"space-evenly"}}><Tn $disabled={s.length===0}><button disabled={s.length===0}onClick={$}>Clear all</button></Tn><An><button onClick={k}>Apply</button></An></Dn></In></$n>};var ul=({data:e=[],numThumbnailsPerPage:t,nextJSOptions:o,tabLabels:a,resultsHeading:l,filterHeading:p,sortByHeading:s,sortByOptions:n,filterValue:c,activeTabIndex:d,leaderboard:C,submitVote:T,isLoading:$,displayShareButton:k,votingModalReminder:S,votingModalDisclaimer:V,isVotingOpen:D,useUniqueLinksForModals:O=!1,enableVideoHover:F=!1,useDetailsSlug:N,usePagination:R=!1,showTags:f=!1,votingButtons:E})=>{let{onReplaceNextRouter:B,onPushNextRouter:G}=o,Le={filters:{allFilters:[],selectedFilters:[],filteredData:c?[]:e},pagination:{numPages:1,currentPage:o.page?Number(o.page):1,currentPageData:[]}},[W,j]=Be(Le),[te,ce]=Be([]),[oe,_]=Be(!1),me=Fi(null),I=Oi({ref:me}),[Z,ge]=Be(-1),{isBreakpoint:fe}=zi("md","<="),U=()=>typeof window!="undefined"?window.location.pathname:void 0;Re(()=>{if(!o.isReady||$)return;let r=c?Hn(e):[];j(i=>P(A({},i),{filters:P(A({},i.filters),{allFilters:r,filteredData:e})}))},[o.isReady,$,e]),Re(()=>{if($||!W.filters.filteredData.length||!o.isReady)return;let{filteredData:r}=W.filters;if(R)if(r.length>t){let i=Math.ceil(r.length/t),m=o.page?Number(o.page):1,g=0<m&&m<=i?m:1,M=qe(g,i);j(L=>P(A({},L),{pagination:{numPages:i,currentPageData:M,currentPage:g}})),Number(o.page)!==g&&B(`${U()}/?page=${g}`,void 0,{shallow:!0})}else j(i=>P(A({},i),{pagination:{numPages:1,currentPageData:r,currentPage:1}})),o.page&&B(`${U()}`,void 0,{shallow:!0});else ce(r.slice(0,t)),o.page&&B(`${U()}`,void 0,{shallow:!0})},[W.filters.filteredData,$,o.isReady]),Re(()=>{!R&&(I!=null&&I.isIntersecting)&&zn()},[I]);let zn=()=>{let r=xe.slice(te.length,te.length+t);ce(i=>[...i,...r])};Re(()=>{let{page:r}=o;if(r){let i=Number(r),m=qe(i);j(g=>P(A({},g),{pagination:P(A({},g.pagination),{currentPageData:m,currentPage:i})}))}},[o.page]);let On=()=>{var M,L;let r=(M=document.getElementById("heading-container"))==null?void 0:M.getBoundingClientRect().top,i=document.body.getBoundingClientRect().top,m=(L=document.getElementsByTagName("header")[0])==null?void 0:L.getBoundingClientRect().height,g=r?r-i-m:0;window.scrollY>g&&window.scrollTo(0,g)},Fn=r=>{r.preventDefault();let i=r.target,m=Number(i.value);Pe(m)},Pe=r=>ee(void 0,null,function*(){On(),yield G(`${U()}/?page=${r}`,void 0,{shallow:!0})}),qe=(r,i)=>{let{filteredData:m}=W.filters;if((i||W.pagination.numPages)<=1)return m;let M=r*t,L=M-t;return m.slice(L,M)},Hn=r=>{if(c&&c.includes(".")){let i={};return r.forEach(m=>{let g=ne(m,c);Array.isArray(g)&&g.forEach(M=>{M.category&&M.name&&(i[M.category]||(i[M.category]=new Set),i[M.category].add(M.name))})}),Object.keys(i).map(m=>({categoryName:m,tagNames:Array.from(i[m])}))}else{let i=new Set;return r.forEach(m=>{let g=m[c];g&&typeof g=="string"&&i.add(g)}),Array.from(i).sort()}},Gn=r=>{let{currentPage:i,numPages:m}=W.pagination,g=i+1;g<=m&&Pe(g)},Wn=r=>{let i=Xe-1;i>=1&&Pe(i)},jn=r=>ee(void 0,null,function*(){if(o.slug&&a){let i=a[r].toLowerCase().replace("_","-");yield G(`/${o.slug[0]}/${i}`)}}),Ke=r=>{var m;let i=[];if(_(!1),r.length&&c?i=e.filter(g=>{let M=ne(g,c);if(typeof M=="string")return r.includes(M);if(Array.isArray(M)){let L=M.map(q=>q.name);return r.every(q=>L.includes(q))}}):i=e,i.length===0&&r.length>0&&_(!0),j(g=>P(A({},g),{filters:P(A({},g.filters),{selectedFilters:r,filteredData:i})})),Z!==-1&&(_(!1),n)){let g=n[Z],M=g.split(" ")[0].toLowerCase();M=(m={student:"firstName",school:"schoolName",video:"video.title"}[M])!=null?m:M;let q=g[g.length-2]==="Z",K=i.sort((H,oi)=>{let ie=ne(H,M),re=ne(oi,M);if(ie&&re){if(typeof ie=="string"&&typeof re=="string"&&(ie=ie.toLowerCase(),re=re.toLowerCase()),ie<re)return q?-1:1;if(ie>re)return q?1:-1}return 0});j(H=>P(A({},H),{filters:P(A({},H.filters),{selectedFilters:r,filteredData:[...K]})}))}},ne=(r,i)=>i.split(".").reduce((m,g)=>m&&m[g],r),_n=r=>{if(ge(r),_(!1),n){let i=n[r],m=i.split(" ")[0].toLowerCase();m==="student"&&(m="firstName"),m==="school"&&(m="schoolName"),m==="video"&&(m="video.title");let g=i[i.length-2]==="Z",M=xe.sort((L,q)=>{let K=ne(L,m),H=ne(q,m);if(K&&H){if(typeof K=="string"&&typeof H=="string"&&(K=K.toLowerCase(),H=H.toLowerCase()),K<H)return g?-1:1;if(K>H)return g?1:-1}return 0});j(L=>P(A({},L),{filters:P(A({},L.filters),{filteredData:[...M]})}))}},Zn=r=>{G(`${U()}?${o.page?`page=${o.page}&`:""}id=${r}`,void 0,{shallow:!0})},Un=()=>{G(`${U()}${o.page?`?page=${o.page}`:""}`,void 0,{shallow:!0})},Yn=r=>{if(r.firstName&&D)return{studentName:`${r.firstName} ${r.lastName}`,schoolName:r.schoolName,educationLevel:r.educationLevel,artWorkTitle:r.artWorkTitle,createdAt:r.createdAt,submitVote:T||(()=>Promise.resolve()),reminder:S,disclaimer:V,isVotingOpen:D}},qn=r=>{G(`${U()}${N?"/details":""}?sId=${r}`)},ze=r=><Pn direction="row"gutterWidth={fe?8:24}>{oe?Kn():null}{r==null?void 0:r.map((i,m)=>{let g=Yn(i);return<Ln xs={6}md={6}lg={4}xl={3}key={m}>{(i.video.posterImage||i.nextImage)&&<div className="single-thumbnail"><Ao id={i.sId}video={i.video}nextImage={i.nextImage?i.nextImage:void 0}thumbnail={i.thumbnail}voteDetails={g}useDetailsSlug={N}displayThumbnail={!0}autoplay={!0}enableVideoHover={F}goToDetailsPage={()=>qn(i.sId)}showTags={f}shareButton={k&&U()&&g?k(g==null?void 0:g.studentName,`${window.location.origin}/${U()}?sId=${i.sId}`):void 0}applyActiveVideoModal={O?Zn:void 0}removeActiveVideoModal={O?Un:void 0}activeVideoModal={o.selectedVideoId}votingButtons={E}/></div>}</Ln>})}</Pn>,Kn=()=><Jo><Sn><J level={4}justify="center">{"We couldn\u2019t find any matches. Clear or adjust your filters to explore more videos."}</J><Cn onClick={()=>{Ke([]),_(!1)}}>Clear filters</Cn></Sn></Jo>,{pagination:Xn,filters:Qn}=W,{numPages:ue,currentPage:Xe,currentPageData:Jn}=Xn,{allFilters:ei,selectedFilters:ti,filteredData:xe}=Qn;return<Pi style={{maxWidth:"1600px",minWidth:"280px",width:"100%",padding:fe?"0px 16px":"0px 24px"}}><Ko>{a!=null&&a.length&&d!==void 0?<Yo tabLabels={a}filterByTab={jn}activeTabIndex={d}/>:null}{C||null}<Pn id="heading-container"><Ln><Xo><J level={4}margin="0px">{`${l} (${xe.length})`}</J><Qo>{p?<Bn options={ei}current={ti}onChange={Ke}menuHeading={p}/>:null}{s&&n?<Ne options={n}current={-1}onChange={_n}menuHeading={s}showMenuHeadingInSelectedState={!0}disabled={oe}/>:null}</Qo></Xo></Ln></Pn>{R?ue>1?ze(Jn):ze(xe):ze(te)}{!R&&<div ref={me}/>}{R&&ue>1?<Po key={ue}onPageChange={Fn}currentPage={Xe}totalPages={ue}onNext={Gn}onPrevious={Wn}/>:null}</Ko></Pi>};export{Go as CASING,Nt as DisplayTags,Bn as DropdownMultiSelector,Ne as DropdownSelector,He as EducationLevelTabs,ye as EducationLevels,ul as Gallery,Lt as GalleryThumbnail,J as Heading,$e as Modal,z as NAV_TABS_TYPES,Uo as NavigationTabs,Po as Pagination,bi as ResultModal,eo as ResultModalType,Eo as StudentArtModal,Ao as Video};
//# sourceMappingURL=index.js.map